import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { InvoiceSaleService } from '../../sales/invoice-sale/invoice-sale.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';
import { RolesAndPermissionsService } from 'src/app/services/roles-and-permissions.service';
import { PositionUserResponse } from 'src/app/models/user.model';
import { PurchasesService } from 'src/app/services/purchases.service';
import { VendorService } from 'src/app/services/vendor.service';
import { ProductService } from 'src/app/services/product.service';
import { Router } from '@angular/router';
import { DateUtil, getLongDate } from 'src/app/common/util';
import { CompanyService } from 'src/app/services/company.service';
import { PurchasesAdministrativeService } from 'src/app/services/purchases-administrative.service';
import { PurchaseOrderService } from 'src/app/services/purchase-order.service';
import { PurchaseOrderDetailResponse, PurchaseOrderResponse } from 'src/app/models/purchase-order.model';
import { PurchasesAssociationService } from 'src/app/services/purchases-association.service';
import { forkJoin } from 'rxjs';
import { CurrencyService } from 'src/app/services/currency.service';
import { ProductCpService } from 'src/app/services/product-cp.service';

@Component({
  selector: 'app-invoice-purchase',
  templateUrl: './invoice-purchase.component.html',
  styleUrls: ['./invoice-purchase.component.scss']
})
export class InvoicePurchaseComponent implements OnInit {
  options = {
    selected: "invoice",
    invoice: { serie: null, number: null, discount: null },
    doc: { number: null }
  }
  total = 0;
  dollar = false;
  permissionType = PermissionTypeEnum;
  creatingNewWarehouse = false;
  filterWarehouses = [];
  filterClients = [];
  filterProvidersPolicy = [];
  filterProducts = [];
  productsList = [];
  vendors = [];
  products = [];
  warehouses = [];
  filterWordOrders: string = null;
  purchaseOrders: PurchaseOrderResponse[] = [];
  purchaseOrdersFilter: PurchaseOrderResponse[] = [];
  purchaseDetailsOrder: PurchaseOrderDetailResponse[] = [];
  currentOrder: PurchaseOrderResponse = null;
  paginationOrders = {
    total: [],
    filter: [],
    pageSize: 5,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  };
  inputs = {
    warehouse: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: 'fa-asterisk',
      color: 'danger',
      tooltip: 'status-warehouse',
      data: null
    }, client: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: 'fa-asterisk',
      color: 'success',
      tooltip: 'status-client',
      data: null
    }, product: {
      value: '',
      verified: false,
      required: false,
      message: '-',
      class: '',
      color: '',
      tooltip: 'status-product',
      data: null,
      purchaseId: null
    }, date: null,
    description: null,
    policy: false,
    providerPolicy: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: 'fa-asterisk',
      color: 'success',
      tooltip: 'status-provider-policy',
      data: null
    }
  };
  timeout = null;
  searchingPrice = false;
  searchProduct = {
    quantity: 1,
    price: 0,
    total: null,
    stock: null,
    prices: [],
    orderDetailId: null
  }
  saving = false;
  success = "";
  showPolicy = false;
  showOC = false;
  ordersAdd: { [key: number]: { productId: number, quantity: number, unitPrice: number, invoiceId: number } } = {}
  exchangeRate = 1.00;
  checkListOwnProducts = false;
  productsCpVendor = [];
  checkAdministration = false;
  loadingConfig = false;

  constructor(
    private toastService: ToastrService,
    private saleService: InvoiceSaleService,
    private warehouseService: WarehouseService,
    private authService: AuthenticationService,
    private purchaseService: PurchasesService,
    private purchaseOrderService: PurchaseOrderService,
    private vendorService: VendorService,
    private roleService: RolesAndPermissionsService,
    private productService: ProductService,
    private companyService: CompanyService,
    private purchaseAdministrativeService: PurchasesAdministrativeService,
    private purchasesAssociationService: PurchasesAssociationService,
    private currencyService: CurrencyService,
    private productCpService: ProductCpService,
    private router: Router
  ) {

  }

  ngOnInit(): void {
    this.getWarehouses();
    this.getVendors();
    this.getProducts();
    this.inputs.date = this.getTodayDate();
    this.getShowPolicy();
    this.getPurchaseOrders();
    this.getExchangeRate();
    this.getConfigListOwnProducts();
    this.getCheckAdministration();
  }

  getShowPolicy() {
    this.companyService.checkCompanyConfigPolicy().subscribe({
      next: (response: ResponseObject) => {
        this.showPolicy = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  getCheckAdministration() {
    this.companyService.checkCompanyConfigAdministration().subscribe({
      next: (response: ResponseObject) => {
        this.checkAdministration = response.data;
        if (this.checkAdministration === true) {
          this.options.selected = 'administrative';
        }
        this.loadingConfig = true;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
        this.loadingConfig = true;
      }
    })
  }

  getTodayDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Los meses comienzan desde 0
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getWarehouses() {
    this.warehouseService.getWarehouseByClue('').subscribe({
      next: (response: ResponseObject) => {
        var warehouseTemp = response.data;
        warehouseTemp.forEach((w) => {
          if (w.logo)
            w.logo = "https://s3.amazonaws.com/rrhh-images/warehouse/logos/" + w.logo;
        });
        this.warehouses = warehouseTemp;
        var idUser = JSON.parse(this.authService.getCurrentUser()).id;
        this.roleService.getUserPosition(idUser).subscribe({
          next: (response: ResponseObject) => {
            var userPosition = response.data as PositionUserResponse[];
            var permissionWarehouse = [];
            if (userPosition.length > 0) {
              userPosition.forEach((u) => {
                permissionWarehouse.push(u.warehouse);
              });
              this.warehouses = warehouseTemp.filter(bodega => permissionWarehouse.includes(bodega.id));
            }
            this.filterWarehouses = this.warehouses;
            if (this.filterWarehouses.length == 1) {
              this.inputs.warehouse.value = this.filterWarehouses[0].name;
              this.inputs.warehouse.class = "fa-check";
              this.inputs.warehouse.verified = true;
              this.inputs.warehouse.data = this.filterWarehouses[0];
            }
          },
          error: (error: any) => {
            this.toastService.error(error.error.message);
          }
        })
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  getVendors() {
    this.vendorService.getProvidesByClue('').subscribe({
      next: (response: ResponseObject) => {
        this.filterClients = response.data;
        this.filterProvidersPolicy = response.data;
        this.vendors = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  getProducts() {
    this.productService.getProductsPurchase('').subscribe(
      (response) => {
        this.products = Object(response)['data'];
        this.filterProducts = this.products;
      },
      (error) => {
        this.toastService.error(error.error.message);
      }
    )
  }

  getConfigListOwnProducts() {
    this.companyService.checkCompanyConfigListOwnProducts().subscribe({
      next: (response: ResponseObject) => {
        this.checkListOwnProducts = response.data;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  getProductsCpByVendor() {
    if (!this.inputs.client.data.id || !this.checkListOwnProducts)
      return;

    this.productCpService.getProducsCPByVendorId(this.inputs.client.data.id).subscribe({
      next: (response: ResponseObject) => {
        this.productsCpVendor = response.data;
        this.filterProductsCp();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  filterProductsCp() {
    if (!this.checkListOwnProducts || !this.productsCpVendor || this.productsCpVendor.length === 0) {
      this.filterProducts = this.products;
      return;
    }

    const allowedProductIds = this.productsCpVendor.map(p => p.productId);
    this.filterProducts = this.products.filter(prod => allowedProductIds.includes(prod.id));
  }


  /**
   * Function that verifies if an input value is empty, correct or erroneous.
   * @param event An event of the input to verify
   * @param type An string, 'warehouse' if the input is for select warehouse or 'client' if the input is for select client
   */
  verifiedInput(event: any, type: string) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '') {
      if (type == 'warehouse') {
        this.changeStatusInput(null, null, 2, 'warehouse');
      } else if (type == 'client') {
        this.changeStatusInput(null, null, 2, 'client');
      } else if (type == 'product') {
        this.changeStatusInput(null, null, 2, 'product');
      } else if (type == 'cashier') {
        this.changeStatusInput(null, null, 2, 'cashier');
      } else if (type == 'providerPolicy') {
        this.changeStatusInput(null, null, 2, 'providerPolicy');
      }
    } else {
      switch (type) {
        case 'warehouse':
          {
            this.filterWarehouses = this.warehouses.filter((w) => {
              return w.id == inputValue || w.name.toLowerCase().includes(inputValue.toLowerCase()) || w.nit == inputValue
            });
            if (this.filterWarehouses.length == 1) {
              this.changeStatusInput(this.filterWarehouses[0], this.filterWarehouses[0].name, 1, 'warehouse');
            } else {
              this.changeStatusInput(null, inputValue, 2, 'warehouse');
            }
            break;
          }
        case 'client': {
          let temp: any = this.vendors.filter((client) => {
            if (inputValue.toLowerCase() == 'cf' || inputValue.toLowerCase() == 'c/f') {
              return client.code.toLowerCase() == 'vcf';
            } else {
              return client.name.toLowerCase().includes(inputValue.toLowerCase()) || client.id == parseInt(inputValue) ||
                client.nit == parseInt(inputValue);
            }
          }
          );
          if (temp.length == 1) {
            this.changeStatusInput(temp[0], temp[0].nit + " - " + temp[0].name, 1, 'client');
          } else {
            if (this.validateNit(inputValue)) {
              this.inputs.client.class = "typing";
              this.saleService.getClientsByNit(inputValue).subscribe({
                next: (response: ResponseObject) => {
                  if (response.data.nit) {
                    this.vendors.push(response.data);
                    this.changeStatusInput(response.data, response.data.nit + " - " + response.data.name, 1, 'client');
                  } else {
                    this.toastService.info("El nit enviado no fue encontrado");
                    this.changeStatusInput(null, inputValue, 2, 'client');
                  }
                },
                error: (error: HttpErrorResponse) => {
                  this.toastService.error(error.error.message);
                }
              });
            } else if (this.validateCui(inputValue)) {
              this.inputs.client.class = "typing";
              this.saleService.getClientsByNit(inputValue).subscribe({
                next: (response: ResponseObject) => {
                  if (response.data.nit) {
                    this.vendors.push(response.data);
                    this.changeStatusInput(response.data, response.data.nit + " - " + response.data.name, 1, 'client');
                  } else {
                    this.toastService.info("El cui enviado no es valido");
                    this.changeStatusInput(null, inputValue, 2, 'client');
                  }
                },
                error: (error: HttpErrorResponse) => {
                  this.toastService.error(error.error.message);
                }
              });
            } else {
              this.changeStatusInput(null, null, 0, 'client');
            }
          }
          break;
        }
        case 'product': {
          let temp: any = this.products.filter((product) =>
            product.name.toLowerCase().includes(inputValue.toLowerCase()) || product.id == parseInt(inputValue)
          );
          if (temp.length == 1) {
            this.changeStatusInput(temp[0], (temp[0].barCode ? temp[0].barCode + ' - ' : '') + temp[0].name, 1, 'product');
          } else {
            this.changeStatusInput(null, null, 0, 'product');
          }
          break;
        }
        case 'providerPolicy': {
          let temp: any = this.vendors.filter((client) => {
            if (inputValue.toLowerCase() == 'cf' || inputValue.toLowerCase() == 'c/f') {
              return client.code.toLowerCase() == 'vcf';
            } else {
              return client.name.toLowerCase().includes(inputValue.toLowerCase()) || client.id == parseInt(inputValue) ||
                client.nit == parseInt(inputValue);
            }
          }
          );
          if (temp.length == 1) {
            this.changeStatusInput(temp[0], temp[0].nit + " - " + temp[0].name, 1, 'client');
          } else {
            if (this.validateNit(inputValue)) {
              this.inputs.providerPolicy.class = "typing";
              this.saleService.getClientsByNit(inputValue).subscribe({
                next: (response: ResponseObject) => {
                  if (response.data.nit) {
                    this.changeStatusInput(response.data, response.data.nit + " - " + response.data.name, 1, 'providerPolicy');
                  } else {
                    this.toastService.info("El nit enviado no fue encontrado");
                    this.changeStatusInput(null, inputValue, 2, 'client');
                  }
                },
                error: (error: HttpErrorResponse) => {
                  this.toastService.error(error.error.message);
                }
              });
            } else if (this.validateCui(inputValue)) {
              this.inputs.providerPolicy.class = "typing";
              this.saleService.getClientsByNit(inputValue).subscribe({
                next: (response: ResponseObject) => {
                  if (response.data.nit) {
                    this.changeStatusInput(response.data, response.data.nit + " - " + response.data.name, 1, 'providerPolicy');
                  } else {
                    this.toastService.info("El cui enviado no es valido");
                    this.changeStatusInput(null, inputValue, 2, 'client');
                  }
                },
                error: (error: HttpErrorResponse) => {
                  this.toastService.error(error.error.message);
                }
              });
            } else {
              this.changeStatusInput(null, null, 0, 'client');
            }
          }
          break;
        }
        default:
          break;
      }
    }
  }

  validateNit(nit: string): boolean {
    const expresionRegular = /^\d{8}$/;
    return expresionRegular.test(nit);
  }

  validateCui(cui: string): boolean {
    const expresionRegular = /^\d{13}$/;
    return expresionRegular.test(cui);
  }

  /**
   * Function that shows visually status of the current warehouse/client
   * @param selected An object that represents the selected value, null if the entered value does not match any warehouse/client.
   * @param newValue An string that represents the new value of the input, null if the entered value does not need to be change.
   * @param status An integer, 1 if the selected value is OK, 2 if is blank and 0 if does not mach any warehouse/client
   * @param type An string, that represents if the input is for 'warehouse' or 'client'
   */
  changeStatusInput(selected: any, newValue: string, status: number, type: string) {
    let tempInput;
    if (type == 'warehouse') {
      tempInput = this.inputs.warehouse;
    } else if (type == 'client') {
      console.log('entro');
      
      tempInput = this.inputs.client;
    } else if (type == 'product') {
      tempInput = this.inputs.product;
    } else if (type == 'providerPolicy') {
      tempInput = this.inputs.providerPolicy;
    }
    tempInput.verified = status == 1;
    if (status == 1) {
      tempInput.data = selected;
      tempInput.value = newValue;
      tempInput.color = "success";
      tempInput.class = 'fa-check';
      if (type == 'client') {
        this.getProductsCpByVendor();
      }
    } else {
      tempInput.data = null;
      tempInput.color = 'danger';
      tempInput.class = (status == 0) ? 'fa-xmark' : 'fa-asterisk';
    }
  }

  handleInput(event: any, type: string) {
    const inputField = event.target as HTMLInputElement;
    const inputValue = inputField.value;
    const input = event.target as HTMLInputElement;
    const parentInput = input.parentElement;
    const divElements = parentInput.getElementsByClassName('suggestions')[0];
    divElements.classList.add('suggestions-show');
    if (type == 'warehouse') {
      /*  */
      clearTimeout(this.timeout);
      this.inputs.warehouse.class = "typing";
      this.timeout = setTimeout(() => {
        this.filterWarehouses = this.warehouses.filter((w) => {
          return w.id == inputValue || w.name.toLowerCase().includes(inputValue.toLowerCase()) || w.nit == inputValue
        })
        if (this.filterWarehouses.length == 0) {
          this.changeStatusInput(null, null, 0, 'warehouse');
        } else {
          this.inputs.warehouse.class = "bx bx-list-check";
        }
      }, 500);
    } else if (type == 'client') {
      this.inputs.client.class = "typing";
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.searchProvider(inputValue);
      }, 300);
    } else if (type == 'providerPolicy') {
      this.inputs.providerPolicy.class = "typing";
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.filterProvidersPolicy = this.vendors.filter((client) =>
          client.name.toLowerCase().includes(inputValue.toLowerCase()) || client.id == parseInt(inputValue) || client.nit == parseInt(inputValue)
        );
        if (this.filterProvidersPolicy.length == 0) {
          this.inputs.providerPolicy.class = "fa-xmark";
        } else {
          this.inputs.providerPolicy.class = "fa-list";
        }
      }, 300);
    } else if (type == 'product') {
      clearTimeout(this.timeout);
      this.inputs.product.class = "typing";
      this.timeout = setTimeout(() => {
        this.saleService.getProductsPurchases(inputValue).subscribe(
          (response) => {
            this.filterProducts = Object(response)['data'];
            if (this.filterProducts.length == 0) {
              this.filterProducts = this.products.filter((product) =>
                product.name.toLowerCase().includes(inputValue.toLowerCase()) || product.id == parseInt(inputValue)
              );
              if (this.filterProducts.length == 0) {
                this.changeStatusInput(null, null, 0, 'product');
              } else {
                this.inputs.product.class = "bx bx-list-check";
              }
            } else {
              if (inputValue != '') {
                this.inputs.product.class = "bx bx-list-check";
              } else {
                this.inputs.product.class = "";
              }
            }
          }, (error) => {
            this.toastService.error(error.error.message);
          });
      }, 500);
    }
  };

  searchProvider(inputValue: string) {
        
    let temp: any = this.vendors.filter((client) => {
      return client.name.toLowerCase().includes(inputValue.toLowerCase()) || client.id == parseInt(inputValue) || client.nit == parseInt(inputValue);
    });

    this.filterClients = temp;
    if (temp.length == 1) {
      this.changeStatusInput(temp[0], temp[0].nit + " - " + temp[0].name, 1, 'client');
    } else {
      if (temp.length == 0) {
        this.inputs.client.class = "typing";
        this.saleService.getProvidersByNit(inputValue).subscribe({
          next: (response: ResponseObject) => {
            if (response) {
              this.vendors.push(response.data);
              this.changeStatusInput(response.data, response.data.nit + " - " + response.data.name, 1, 'client');
            } else {
              this.toastService.info("El cui enviado no es valido");
              this.changeStatusInput(null, inputValue, 0, 'client');
            }
          },
          error: (error: HttpErrorResponse) => {
            this.changeStatusInput(null, inputValue, 0, 'client');
            this.toastService.error(error.error.message);
          }
        });
      } else {
        this.inputs.client.class = "fa-list";
        this.inputs.client.verified = false;
        this.inputs.client.data = null;
      }
    }
  }

  addProduct(orderId: number) {
    this.filterProducts = this.products;
    var tempProduct = this.inputs.product.data;
    var total = this.searchProduct.quantity * this.searchProduct.price;

    this.productsList.push({
      id: tempProduct.id,
      name: tempProduct.name,
      quantity: this.searchProduct.quantity,
      price: this.searchProduct.price,
      total: total,
      data: tempProduct,
      orderId: orderId,
      orderDetailId: this.searchProduct.orderDetailId
    });

    this.updateTotalAloneProducts();
    this.inputs.product.class = '';
    setTimeout(() => {
      this.inputs.product.value = "";
      this.inputs.product.data = null;
      this.inputs.product.verified = false;
      this.searchProduct.quantity = 1;
      this.searchProduct.price = 0;
      this.searchProduct.total = 0;
      this.scrollToEnd();
    }, 100);
  }

  addProductsOrder(purchaseOrder: PurchaseOrderResponse) {
    if (!purchaseOrder.id) {
      return;
    }
    this.purchaseOrderService.getOrder(purchaseOrder.id).subscribe({
      next: (response: any) => {
        if (response.data.length > 0) {
          response.data.forEach(element => {
            if (element.statusType != 1) {
              this.inputs.product.data = element.productData
              this.searchProduct.quantity = element.quantity - element.quantityReceived;
              this.searchProduct.price = element.cost;
              this.searchProduct.orderDetailId = element.id;
              this.addProduct(purchaseOrder.id);
            }
          });
        }
      },
      error: (error) => {
        this.toastService.error("Error al obtener los detalles del pedido", "Error");
      }
    });
  }

  showDetails(purchaseOrder: PurchaseOrderResponse) {
    if (!purchaseOrder.id) {
      return;
    }
    this.purchaseOrderService.getOrder(purchaseOrder.id).subscribe({
      next: (response: any) => {
        this.purchaseDetailsOrder = response.data;
        this.currentOrder = purchaseOrder;
      },
      error: (error) => {
        this.toastService.error("Error al obtener los detalles del pedido", "Error");
      }
    });
  }

  scrollToEnd() {
    const miDiv = document.getElementById('miDiv') as HTMLDivElement;
    const con1 = document.getElementById('product-div') as HTMLDivElement;
    const con = document.getElementById('container-sale') as HTMLDivElement;
    const titlePage = document.getElementById('title-page') as HTMLDivElement;
    const titleProductH = document.getElementById('title-product-h') as HTMLHeadingElement;
    miDiv.scrollTo(0, miDiv.scrollHeight);
    con1.scrollIntoView();
    if (con.clientWidth < 575) {
      con.scrollTop = con.scrollTop - titlePage.clientHeight + titleProductH.clientHeight + 10;
    } else {
      con.scrollTop = con.scrollTop - titlePage.clientHeight;
    }
  }

  changeValue(product: any, type: string) {
    product.total = product.quantity * product.price;
    this.updateTotalAloneProducts();
  }

  deleteProduct(id: string) {
    for (let i = 0; i < this.productsList.length; i++) {
      if (id == this.productsList[i].id) {
        this.productsList.splice(i, 1);
        break;
      }
    }
    this.updateTotalAloneProducts();
  }

  updateTotalAloneProducts() {
    var newTotal = 0;
    this.productsList.forEach(element => {
      newTotal += element.price * element.quantity;
    });
    this.total = newTotal;
  }

  savePurchase() {
    if (!this.saving) {
      this.saving = true;
      var invoiceData = {
        cash: null,
        creditDate: null,
        date: DateUtil.parseDateToMilliseconds(this.inputs.date),
        description: (this.inputs.description) ? this.inputs.description : '',
        detail: [],
        invoice: (this.options.selected == 'invoice' || this.options.selected == 'administrative'),
        number: (this.options.selected == 'invoice' || this.options.selected == 'administrative') ? this.options.invoice.number : this.options.doc.number,
        providerId: this.inputs.client.data.id,
        series: this.options.invoice.serie,
        warehouseId: this.inputs.warehouse.data.id,
        policy: this.inputs.policy,
        providerPolicy: this.inputs.providerPolicy?.data?.id ? this.inputs.providerPolicy.data.id : null,
        isDollar: this.inputs.policy && this.dollar,
        currency: (this.inputs.policy && this.dollar) ? 1 : 0,
        exchangeRate: (this.inputs.policy && this.dollar) ? this.exchangeRate : 1
      }


      let ordersIdSelected = new Set<number>();
      let detailsSelectedOrder = [];
      for (let i = 0; i < this.productsList.length; i++) {
        const product = this.productsList[i];
        if (product.orderId != null) {
          ordersIdSelected.add(product.orderId)
        }

        if (product.orderDetailId != null) {
          detailsSelectedOrder.push({
            productId: product.id,
            quantity: product.quantity,
            price: product.price,
            orderId: product.orderId,
            orderDetailId: product.orderDetailId
          })
        }

        invoiceData.detail.push({
          productId: product.id,
          quantity: product.quantity,
          price: product.price,
          //detailId: product.orderDetailId ? product.orderDetailId : null
        });
      }

      console.log("invoiceData", invoiceData.detail);


      if (this.options.selected == 'administrative') {
        this.purchaseAdministrativeService.postInvoice(invoiceData).subscribe({
          next: (response: ResponseObject) => {
            this.saveAssociatedPurchaseOrder(response.data.id, ordersIdSelected, detailsSelectedOrder)
            this.saving = false;
            this.success = "Factura guardada!";
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
              this.success = "";
              this.refresh();
            }, 3000);
          },
          error: (error: HttpErrorResponse) => {
            this.saving = false;
            this.toastService.error(error.error.message);
          }
        });
      } else {
        this.purchaseService.postInvoice(invoiceData).subscribe({
          next: (response: ResponseObject) => {
            this.saveAssociatedPurchaseOrder(response.data.id, ordersIdSelected, detailsSelectedOrder)
            this.saving = false;
            this.success = "Factura guardada!";
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
              this.success = "";
              this.refresh();
            }, 3000);
          },
          error: (error: HttpErrorResponse) => {
            this.saving = false;
            this.toastService.error(error.error.message);
          }
        });
      }
    }
  }

  saveAssociatedPurchaseOrder(invoiceId: number, ordersIdSelected: Set<number>, detailsSelectedOrder: Array<any>) {
    const requests = [...ordersIdSelected].map(element =>
      this.purchasesAssociationService.createRelationPurchaseOrderIngress(element, invoiceId)
    );

    forkJoin(requests).subscribe({
      next: (response) => {
        this.toastService.success("Factura de Compra asociada a la(s) orden(es)", "Exito")
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Erro al crear la asociacion de la factura de compra", "Error");
      }
    });

    const requestsDetail = detailsSelectedOrder.map(element =>
      this.purchaseOrderService.putEditDetailFromInvoice(
        { ...element, providerInvoiceId: invoiceId }, element.orderId, element.orderDetailId)
    );

    forkJoin(requestsDetail).subscribe({
      next: (response) => {
        this.toastService.success("Detalle de order de Compra actualizada", "Exito")
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Erro al actalizar el detalle de la orden de compra", "Error");
      }
    });

  }

  refresh() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  getPurchaseOrders() {
    this.purchaseOrderService.getOrdersActive().subscribe({
      next: (response: ResponseObject) => {
        this.purchaseOrders = response.data;
        this.setOrders();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  setOrders() {
    this.purchaseOrders = this.purchaseOrders.sort((a, b) => Number(b.number) - Number(a.number));
    this.paginationOrders.total = this.purchaseOrders;
    this.resetPagination();
  }

  resetPagination() {
    this.paginationOrders.filter = this.paginationOrders.total.slice(0, this.paginationOrders.pageSize);
    this.paginationOrders.pageIndex = 0;
    this.paginationOrders.lastElement = this.paginationOrders.filter.length;
    this.paginationOrders.startElement = 0;
  }

  onInputChangeOrder(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.filterWordOrders = value;
    this.searching();
  }

  searching() {
    this.paginationOrders.total = this.purchaseOrders.filter((order) => {
      return order.id + '' == this.filterWordOrders || order.number + '' == this.filterWordOrders ||
        order.providerData.name.toLowerCase().includes(this.filterWordOrders.toLowerCase()) ||
        order.user + "" == this.filterWordOrders
    });
    this.paginationOrders.pageIndex = 0;
    this.paginationOrders.startElement = 0;
    this.paginationOrders.filter = this.paginationOrders.total.slice(0, this.paginationOrders.pageSize);
    this.paginationOrders.lastElement = this.paginationOrders.filter.length;
  }

  formatDate(date: any): Date {
    return new Date(date);
  }

  getExchangeRate() {
    this.currencyService.getExchangeDollar(getLongDate(this.inputs.date)).subscribe({
      next: (response: ResponseObject) => {
        this.exchangeRate = Number(response.data);
      },
      error: (error: HttpErrorResponse) => {
        if (this.inputs.policy && this.dollar)
          this.toastService.error("Error al obtener la tasa de cambio", "Error");

      }
    });
  }
}
